import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

ReactDOM.render(
	<React.StrictMode>
		<Router>
			<div style={{float: "right", margin: 10}}>
						<a href="/en-EN"><img src="assets/english.png" width="50"/></a>
						<a href="/pl-PL"><img src="assets/polish.png" width="50"/></a>
      </div>
			<Switch>
				<Route path="/en-EN">
					<App lang="en_EN" />
				</Route>
				<Route path="/pl-PL">
					<App lang="pl_PL" />
				</Route>
				<Route path="/">
					<App lang="pl_PL" />
				</Route>
			</Switch>
		</Router>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
